import React from 'react';

// NewsPicks 番組の告知バナー（FUNDINNO-5255）。ERB の shared/_news_picks_banner と同じ見た目を React ページで出す。
// props は NewsPicksProgramHelper#news_picks_program_banner_props が作る。配信開始前は null が渡り、呼び出し側で描画しない。
export interface NewsPicksBannerProps {
  linkUrl: string;
  pcImageUrl: string;
  spImageUrl: string;
}

interface Props {
  banner: NewsPicksBannerProps;
  // true なら幅に関わらず SP 用（338×200）だけを出す（案件一覧の左ナビのように狭い枠に置くとき）
  spOnly?: boolean;
  className?: string;
}

const ALT =
  '田中渓氏×COO大浦 番組出演 富裕層のポートフォリオ見直し戦略 動画をみる';

export default function NewsPicksBanner({
  banner,
  spOnly = false,
  className,
}: Props) {
  const classNames = ['news-picks-banner', className].filter(Boolean).join(' ');
  return (
    <div className={classNames}>
      <a
        className="news-picks-banner__link"
        href={banner.linkUrl}
        target="_blank"
        rel="noopener noreferrer"
      >
        {spOnly ? (
          <img
            className="news-picks-banner__image"
            src={banner.spImageUrl}
            width={338}
            height={200}
            alt={ALT}
          />
        ) : (
          <>
            <img
              className="news-picks-banner__image news-picks-banner__image--pc"
              src={banner.pcImageUrl}
              width={598}
              height={88}
              alt={ALT}
            />
            <img
              className="news-picks-banner__image news-picks-banner__image--sp"
              src={banner.spImageUrl}
              width={338}
              height={200}
              alt={ALT}
            />
          </>
        )}
      </a>
    </div>
  );
}
